import script from "./total.vue?vue&type=script&setup=true&lang=js"
export * from "./total.vue?vue&type=script&setup=true&lang=js"

import "./total.vue?vue&type=style&index=0&id=8a0a9f0c&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a0a9f0c"]])

export default __exports__